import * as Stomp from "stompjs";
import * as SockJS from "sockjs-client";
import { BehaviorSubject } from "rxjs";

class BinanceLtpWebsocket {
  messageSource = new BehaviorSubject(" ");
  currentMessage = this.messageSource.asObservable();

  reqNo = null;
  buyingasset = null;
  webSocketAPI = null;
  obj = null;
  sellingasset = null;
  ticker = null;
  depth = null;
  trade = null;
  stompClient = null;
  assetPair = null;

  webSocketEndPoint = "https://copytrading-socket.paybito.com/socket/websocket";
  topic = "/topic/name";

  constructor() {
    this.errorCallBack = this.errorCallBack.bind(this);
  }

  connect() {
    console.log("binance CONNECT");

    const token = localStorage.getItem("access_token");
    if (token !== null && token !== undefined) {
      let ws = new SockJS(this.webSocketEndPoint);
      this.stompClient = Stomp.over(ws);
      this.stompClient.debug = null;

      this.stompClient.connect(
        {},
        (frame) => {
          this.stompClient.subscribe(this.topic, (sdkEvent) => {
            this.onMessageReceived(sdkEvent);
          });
        },
        this.errorCallBack
      );
    } else {
      console.log("No access token");
      window.location.href = "https://trade.paybito.com/";
    }
  }

  disconnect() {
    if (this.stompClient !== null) {
      this.stompClient.disconnect();
    }
  }

  errorCallBack(error) {
    console.log("errorCallBack -> " + error);
    setTimeout(() => {
      this.connect();
    }, 5000);
  }

  send(message) {
    if (this.stompClient) {
      this.stompClient.send("/app/sendRequest", {}, JSON.stringify(message));
    }
  }

  onMessageReceived(message) {
    const obj = JSON.parse(message.body);
    this.changeMessage(obj);
  }

  changeMessage(obj) {
    this.messageSource.next(obj);
  }

  subscribeToData() {
    this.assetPair = localStorage
      .getItem("selected_derivative_asset_pair")
      ?.toLowerCase();
    this.ticker = "@ticker";
    this.depth = "@depth";
    this.trade = "@trade";
    this.reqNo = Math.floor(Math.random() * 1000) + 1;

    const req = {
      method: "SUBSCRIBE",
      params: [
        this.assetPair + this.ticker,
        this.assetPair + this.depth,
        this.assetPair + this.trade,
      ],
      id: this.reqNo,
    };

    this.send(req);
  }

  unsubscribeFromData() {
    try {
      if (localStorage.getItem("lastAssetPair")) {
        this.assetPair = localStorage
          .getItem("selected_derivative_asset_pair")
          ?.toLowerCase();
        this.ticker = "@ticker";
        this.depth = "@depth";
        this.trade = "@trade";

        const req = {
          method: "UNSUBSCRIBE",
          params: [
            this.assetPair + this.ticker,
            this.assetPair + this.depth,
            this.assetPair + this.trade,
          ],
          id: this.reqNo,
        };

        this.send(req);
      }
    } catch (e) {
      //   location.reload();
    }
  }
}

export default BinanceLtpWebsocket;
